/* @flow */

import React from 'react';
import _ from 'lodash';
import cx from 'classnames';
import { CubeGrid } from 'better-react-spinkit';

import classes from './Loading.scss';

type PropsType = {
  col: number,
  color: string,
  loaderStyle: CSSStyleDeclaration,
  row: number,
  size: number,
  text: string,
  textStyle: CSSStyleDeclaration,
};

export const Loading = (props: PropsType) => (
  <div className={cx(classes.wrapper, 'p-5')}>
    <CubeGrid {..._.pick(props, ['col', 'color', 'row', 'size'])} style={props.loaderStyle} />
    <h3 style={props.textStyle}>
      {props.text}
    </h3>
  </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js